/**
 * @file Web gallery folder redirect (join code to ID).
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import get from 'lodash.get';

import { JoinCodeByCodeForWebGalleryDiscovery } from '../graphql/queries/code';
import RedirectWithStatus from '../../../components/routing/RedirectWithStatus';
import { prependAccountSlug } from '../../../util/account';

const withCodeRedirect = WrappedComponent =>
  class WithCodeRedirectWrapper extends Component {
    static propTypes = {
      loading: PropTypes.bool,
      albumFolder: PropTypes.shape({
        id: PropTypes.string,
        account: PropTypes.shape({
          slug: PropTypes.string,
        }).isRequired,
      }),
      match: PropTypes.shape({
        slug: PropTypes.string,
      }),
    };

    render() {
      const { albumFolder, ...props } = this.props;

      if (albumFolder) {
        return (
          <RedirectWithStatus
            status={301}
            to={prependAccountSlug(
              `/galleries/view/folder/${albumFolder.id}`,
              albumFolder,
            )}
          />
        );
      }

      return <WrappedComponent {...props} />;
    }
  };

const WebGalleryFolderCodeRedirect = WrappedComponent => {
  const withAlbumFolderByCode = graphql(JoinCodeByCodeForWebGalleryDiscovery, {
    options: ({ match }) => ({
      variables: {
        code: match.params.folderId,
      },
    }),
    props: ({ data: { joinCodeByCode, loading } }) => ({
      albumFolder: get(joinCodeByCode, 'album_folder'),
      loading,
    }),
  });

  return compose(
    withRouter,
    withAlbumFolderByCode,
    withCodeRedirect,
  )(WrappedComponent);
};

export { withCodeRedirect };

export default WebGalleryFolderCodeRedirect;
